<template>
    <div id="astro-dashboard">
        <div class="container">
            <div class="row margin-botton-20 padding-botton-20">
                <div class="col-md-12">

                    <div class="row" v-show="isLocatorEnabled">
                        <div class="col-md-12">
                            <div class="card w-100 border-0" style="width: 18rem; margin-bottom: 10px; margin-top: 10px; border-radius: 12px;">
                                <div class="card-body" style="background-color: rgba(25,135,84,0.15); border-radius: 12px;">
                                    <Locator />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card w-100" style="width: 18rem; margin-bottom: 10px; margin-top: 10px;">
                                <div class="card-body" style="background-color: rgba(0,0,0,0.03)">
                                    <nav class="nav nav-pills nav-fill justify-content-center">
                                        <a :class="tabClass('sunrise-sunset')"  href="/sunrise-sunset"  @click.prevent="setTab('sunrise-sunset')">Sunrise Sunset</a>
                                        <a :class="tabClass('twilight')"         href="/twilight"         @click.prevent="setTab('twilight')">Twilights</a>
                                        <a :class="tabClass('moonrise-moonset')" href="/moonrise-moonset" @click.prevent="setTab('moonrise-moonset')">Moonrise Moonset</a>
                                        <a :class="tabClass('solunar')"          href="/solunar"          @click.prevent="setTab('solunar')">Solunar</a>
                                        <a :class="tabClass('moon-phases')"      href="/moon-phases"      @click.prevent="setTab('moon-phases')">Moon Phases</a>
                                        <a :class="tabClass('seasons')"          href="/seasons"          @click.prevent="setTab('seasons')">Seasons</a>
                                        <a :class="tabClass('planets')"          href="/planets"          @click.prevent="setTab('planets')">Planets</a>
                                        <a :class="tabClass('journal')"          href="/journal"          @click.prevent="setTab('journal')">Journal</a>
                                        <a :class="tabClass('tides')"            href="/tides"            @click.prevent="setTab('tides')">Tides</a>
                                        <a :class="tabClass('world-clock')"      href="/world-clock"      @click.prevent="setTab('world-clock')">World Clock</a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card w-100" style="width: 18rem;">
                                <div class="card-body">

                                    <div class="card-title">
                                        <h1 class="h4" style="margin-bottom: 0; padding-bottom: 0;">
                                            {{ TAB_NAMES[currentTab] }}
                                            <a @click="showInfo = !showInfo" class="btn btn-link btn-sm" style="font-size:12px; margin-left: 4px; padding-left: 0; margin-top:1px;">
                                                <span>{{ showInfo ? 'close' : 'info' }} <font-awesome-icon :icon="showInfo ? ['fas','times'] : ['fas','info-circle']" /></span>
                                            </a>
                                            <button v-if="currentTab === 'journal'" @click="copyRssUrl" class="btn btn-link btn-sm" style="font-size:12px; padding-left: 0; margin-top:1px;" :title="rssCopied ? 'Copied!' : 'Copy RSS feed URL'">
                                                <span v-if="rssCopied">copied! <font-awesome-icon :icon="['fas', 'check']" /></span>
                                                <span v-else>rss <font-awesome-icon :icon="['fas', 'rss']" /></span>
                                            </button>
                                            <button v-if="city.slug" @click="shareTabUrl" class="btn btn-link btn-sm" style="font-size:12px; padding-left: 0; margin-top:1px;" :title="tabShareCopied ? 'Copied!' : 'Copy link to this view'">
                                                <span v-if="tabShareCopied">copied! <font-awesome-icon :icon="['fas', 'check']" /></span>
                                                <span v-else>share <font-awesome-icon :icon="['fas', 'link']" /></span>
                                            </button>
                                        </h1>
                                        <div v-show="showInfo" style="margin-top: 8px; margin-bottom: 4px;">
                                            <TabInfoPanel :tab="currentTab" @close="showInfo = false" />
                                        </div>
                                        <h2 v-if="city.name" class="h5" :style="{ marginBottom: isCalendarEnabled ? '5px' : '30px' }">
                                            <small>near {{ city.name }}, {{ city.region_name }}
                                            <br>{{ timeFrame }}</small>
                                            <a v-if="currentTab !== 'world-clock'" @click="isCalendarEnabled = !isCalendarEnabled" class="btn btn-link btn-sm" style="font-size:12px; margin-left: 8px; padding-left: 0; margin-top:1px;">
                                                <span>{{ isCalendarEnabled ? 'close' : 'change' }} <font-awesome-icon :icon="isCalendarEnabled ? ['fas','times'] : ['fas','calendar-alt']" /></span>
                                            </a>
                                        </h2>
                                    </div>

                                    <div v-if="apiLocked" class="text-center" style="padding: 40px 0;">
                                        <p><font-awesome-icon :icon="['fas', 'lock']" size="2x" /></p>
                                        <p>This service is currently unavailable.</p>
                                    </div>
                                    <div v-else>
                                        <div class="row justify-content-center" v-show="isCalendarEnabled">
                                            <div class="col-md-10">
                                                <div class="card w-100 border-0" style="margin-bottom: 10px; margin-top: 5px; border-radius: 12px;">
                                                    <div class="card-body d-flex justify-content-center" style="background-color: rgba(25,135,84,0.15); border-radius: 12px;">
                                                        <Calendar :current-tab="currentTab" @close="isCalendarEnabled = false" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <TabWorldClock      v-show="currentTab === 'world-clock'"      :active="currentTab === 'world-clock'" />
                                        <TabSunriseSunset   v-show="currentTab === 'sunrise-sunset'"   :active="currentTab === 'sunrise-sunset'" />
                                        <TabMoonriseMoonset v-show="currentTab === 'moonrise-moonset'" :active="currentTab === 'moonrise-moonset'" />
                                        <TabTwilight        v-show="currentTab === 'twilight'"         :active="currentTab === 'twilight'" />
                                        <TabMoonPhases      v-show="currentTab === 'moon-phases'"      :active="currentTab === 'moon-phases'" />
                                        <TabSeasons         v-show="currentTab === 'seasons'"          :active="currentTab === 'seasons'" />
                                        <TabPlanets         v-show="currentTab === 'planets'"          :active="currentTab === 'planets'" />
                                        <TabJournal         v-show="currentTab === 'journal'"          :active="currentTab === 'journal'" />
                                        <TabTides           v-show="currentTab === 'tides'"            :active="currentTab === 'tides'" />
                                        <TabSolunar         v-show="currentTab === 'solunar'"          :active="currentTab === 'solunar'" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card w-100 border-0" style="width: 18rem; margin-bottom: 10px; margin-top: 10px;">
                                <div class="card-body text-end" style="background-color: rgba(0,0,0,0.02)">
                                    <span style="font-size: 80%" class="text-end">Sunrise &amp; sunset times, moon phases, twilight, solstices, planet positions, tides, solunar, and world clock — free astronomical tools for any location on Earth.</span>
                                    <br><span style="font-size: 80%" class="text-end"><a href="https://calendula.lxcor.com">calendula.lxcor.com</a></span>
                                    <br><span style="font-size: 80%" class="text-end"><router-link to="/api">Calendula API</router-link> — REST API for developers &nbsp;·&nbsp; <a href="/portfolio.html" target="_blank">Portfolio</a></span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { getCookie, setCookie } from '@/utils/cookie'
import Calendar from './Calendar'
import Locator from '../geo/Locator'
import TabInfoPanel from './TabInfoPanel'
import TabWorldClock from './TabWorldClock'
import TabSunriseSunset from './TabSunriseSunset'
import TabMoonriseMoonset from './TabMoonriseMoonset'
import TabTwilight from './TabTwilight'
import TabMoonPhases from './TabMoonPhases'
import TabSeasons from './TabSeasons'
import TabPlanets from './TabPlanets'
import TabJournal from './TabJournal'
import TabTides from './TabTides'
import TabSolunar from './TabSolunar'

const INFO_COOKIE = 'calendula_info'
const TAB_COOKIE = 'calendula_tab'
const VALID_TABS = new Set(['sunrise-sunset', 'moonrise-moonset', 'solunar', 'twilight', 'moon-phases', 'seasons', 'planets', 'world-clock', 'journal', 'tides'])

const TAB_NAMES = {
    'world-clock':      'World Clock',
    'sunrise-sunset':   'Sunrise & Sunset',
    'moonrise-moonset': 'Moonrise & Moonset',
    'twilight':         'Twilight Times',
    'moon-phases':      'Moon Phases',
    'seasons':          'Seasons',
    'planets':          'Planet Positions',
    'journal':          'Astronomic Journal',
    'tides':            'Tide Times',
    'solunar':          'Solunar Calendar',
}

const TAB_DESCRIPTIONS = {
    'sunrise-sunset':   'Accurate sunrise and sunset times for {city}. Track sun direction, altitude, distance from Earth, and total day length updated in real time.',
    'moonrise-moonset': 'Moonrise and moonset times for {city}. Includes current moon phase, illumination percentage, direction, altitude, and distance from Earth.',
    'twilight':         'Civil, nautical, and astronomical twilight times for {city}. Know exactly when dusk and dawn begin and end every day for your location.',
    'moon-phases':      'Moon phase calendar for {city}. Exact dates and times for new moon, first quarter, full moon, and last quarter phases throughout the month.',
    'seasons':          'Exact dates and times for solstices and equinoxes — when spring, summer, autumn, and winter officially begin in the current year worldwide.',
    'planets':          'Planet positions and visibility for {city}. Rise and set times, altitude, direction, and distance for Mercury, Venus, Mars, Jupiter, Saturn, Uranus, and Neptune.',
    'world-clock':      'Current local time in major cities around the world. Compare time zones across continents and track international times at a glance.',
    'journal':          'All astronomical events for {city} today in a single chronological view — sunrise, sunset, twilight, moonrise, moonset, moon phases, and every planet rise and set.',
    'tides':            'High and low tide times and heights for {city}. Predicted from the EOT20 global ocean tide model — no internet required at request time.',
    'solunar':          'Solunar activity forecast for {city}. Major and minor periods for the day, overall activity rating, and current moon phase — useful for planning fishing and wildlife outings.',
}

export default {
    name: 'Dashboard',
    components: {
        Calendar, Locator, TabInfoPanel,
        TabWorldClock, TabSunriseSunset, TabMoonriseMoonset, TabTwilight,
        TabMoonPhases, TabSeasons, TabPlanets, TabJournal, TabTides, TabSolunar,
    },
    data() {
        return {
            TAB_NAMES,
            currentTab: 'sunrise-sunset',
            isCalendarEnabled: false,
            showInfo: false,
            rssCopied: false,
            tabShareCopied: false,
        }
    },
    mounted() {
        const pathTab = this.$route.path.replace(/^\/|\/$/g, '')
        if (pathTab && VALID_TABS.has(pathTab)) {
            this.currentTab = pathTab
        } else if (this.$route.params.tab && VALID_TABS.has(this.$route.params.tab)) {
            this.currentTab = this.$route.params.tab
        } else {
            const saved = getCookie(TAB_COOKIE)
            if (saved && VALID_TABS.has(saved)) this.currentTab = saved
        }
        this.updateMeta(this.currentTab)
        if (!pathTab) {
            // Home route: override canonical back to root — the tab canonical set above is wrong for /
            const canonical = document.querySelector('link[rel="canonical"]')
            if (canonical) canonical.setAttribute('href', 'https://calendula.lxcor.com/')
        }
        this.showInfo = getCookie(INFO_COOKIE) === 'true'
        if (!this.date) this.$store.commit('setDate', new Date())
    },
    computed: {
        ...mapState(['city', 'date', 'isLocatorEnabled', 'apiLocked']),
        timeFrame() {
            if (!this.date) return ''
            const d = this.date
            const d1 = `for ${d.toLocaleString('en-US', { month: 'short' })} ${d.getDate()} ${d.getFullYear()}`
            const d3 = `for ${d.getFullYear()}`
            return { 'world-clock': '', 'sunrise-sunset': d1, 'moonrise-moonset': d1, 'solunar': d1, 'twilight': d1, 'moon-phases': d1, 'seasons': d3, 'planets': d1, 'journal': d1, 'tides': d1 }[this.currentTab] || ''
        },
        journalRssUrl() {
            const base = process.env.NODE_ENV === 'development'
                ? `http://${window.location.hostname}:8080/`
                : 'https://api.calendula.lxcor.com/'
            return `${base}astra/journal/rss/${this.city.slug}/`
        },
    },
    watch: {
        $route(to) {
            const tab = to.params.tab
            if (tab && VALID_TABS.has(tab) && tab !== this.currentTab) {
                this.setTab(tab)
            }
        },
        showInfo(val) { setCookie(INFO_COOKIE, val) },
    },
    methods: {
        tabClass(tab) {
            return tab === this.currentTab ? 'nav-link active' : 'nav-link'
        },
        updateMeta(tab) {
            const cityName = this.city && this.city.name ? this.city.name : ''
            const cityStr = cityName ? ` near ${cityName}` : ''
            const title = `${TAB_NAMES[tab]}${cityStr} — Calendula`
            const desc = TAB_DESCRIPTIONS[tab].replace('{city}', cityName || 'your location')
            const url = `https://calendula.lxcor.com/${tab}`

            document.title = title

            const setMeta = (attr, val, content) => {
                let el = document.querySelector(`meta[${attr}="${val}"]`)
                if (!el) { el = document.createElement('meta'); el.setAttribute(attr, val); document.head.appendChild(el) }
                el.setAttribute('content', content)
            }

            setMeta('name', 'description', desc)
            setMeta('property', 'og:title', title)
            setMeta('property', 'og:description', desc)
            setMeta('property', 'og:url', url)
            setMeta('name', 'twitter:title', title)
            setMeta('name', 'twitter:description', desc)

            const canonical = document.querySelector('link[rel="canonical"]')
            if (canonical) canonical.setAttribute('href', url)

            const pageSchema = document.getElementById('page-schema')
            if (pageSchema) pageSchema.textContent = JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                'name': title,
                'description': desc,
                'url': url,
                'isPartOf': { '@type': 'WebSite', 'url': 'https://calendula.lxcor.com' },
            })
        },
        setTab(tab) {
            this.currentTab = tab
            setCookie(TAB_COOKIE, tab)
            this.updateMeta(tab)
            this.$router.push(`/${tab}`).catch(() => {})
        },
        shareTabUrl() {
            const url = `${window.location.origin}/city/${this.city.slug}/${this.currentTab}`
            const done = () => {
                this.tabShareCopied = true
                setTimeout(() => { this.tabShareCopied = false }, 2000)
            }
            if (navigator.share) {
                navigator.share({ url, title: `${this.city.name} — ${this.TAB_NAMES[this.currentTab]}` }).catch(() => {})
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(done)
            } else {
                const el = document.createElement('textarea')
                el.value = url
                el.style.position = 'fixed'
                el.style.opacity = '0'
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                done()
            }
        },
        copyRssUrl() {
            const url = this.journalRssUrl
            const done = () => {
                this.rssCopied = true
                setTimeout(() => { this.rssCopied = false }, 2000)
            }
            if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(done)
            } else {
                const el = document.createElement('textarea')
                el.value = url
                el.style.position = 'fixed'
                el.style.opacity = '0'
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                done()
            }
        },
    },
}
</script>

<style scoped>
.margin-botton-20 { margin-bottom: 20px; }
.padding-botton-20 { padding-bottom: 20px; }
</style>
